import { Flex } from 'antd';
import BrandLogo from 'components/BrandLogo';
import styles from './index.module.scss';

function Header() {
  return (
    <Flex justify='center' align='center' className={styles.container}>
      <BrandLogo />
    </Flex>
  );
}

export default Header;
